export const SCANNED_INVOICE = "SCANNED_INVOICE";
